module.exports = __webpack_public_path__ + "static/media/elementary-school-coding.60120aa6.png";